module.exports = __webpack_public_path__ + "img/recommendedapps.65d2a11d.svg";